import { useState } from "react";
import { setQuestionAnswers } from "../services/memberService";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { useHistory } from "react-router-dom";
import { NotRelevantTag } from "../helpers/Enums";
import { QuestionTagProps } from "./QuestionTag";
import { COMPLETED_PROFILE_PAGE } from "../navigation/Constants";

type Tag = {
  text: string;
  value: number;
  isSelected: boolean;
};

function InterestQuestion(props: any) {
  const history = useHistory();
  const [error, setError] = useState<string>("");
  const [tags, setTags] = useState<Tag[]>(props?.question.tags);
  const member = useSelector((state: RootState) => state.member);

  const handleTagSelect = async (tagValue: number) => {
    setError("");
    const selectedTags = tags.filter((tag) => tag.isSelected);
    if (
      selectedTags.length === 8 &&
      selectedTags.some((tag) => tag.value === tagValue)
    ) {
      setTags(
        tags.map((tag) => {
          return tag.value === tagValue
            ? { ...tag, isSelected: !tag.isSelected }
            : tag;
        })
      );
      return;
    }
    if (selectedTags.length === 8) {
      setError("אפשר לבחור עד 8 תחומי עניין");
      return;
    }
    setTags(
      tags.map((tag) => {
        return tag.value === tagValue
          ? { ...tag, isSelected: !tag.isSelected }
          : tag;
      })
    );
  };

  const handleUnselectAll = () => {
    setTags(
      tags.map((tag) => {
        return { ...tag, isSelected: false };
      })
    );
  };

  const handleSubmit = async (
    event: React.FormEvent<HTMLFormElement>,
    defaultValue = false
  ) => {
    event.preventDefault();
    const selectedTags = defaultValue
      ? [NotRelevantTag.NOT_RELEVANT]
      : tags.filter((tag) => tag.isSelected).map((tag) => tag.value);

    if (selectedTags.length > 8) {
      setError("אפשר לבחור עד 8 תחומי עניין");
      return;
    }
    setError("");

    setQuestionAnswers(member.memberCode, {
      questionId: props.question.questionId,
      tags: selectedTags,
    });
    if (props.hasNext) {
      if (props?.hasNext()) {
        props?.next();
      } else {
        history.push(COMPLETED_PROFILE_PAGE);
        // history.goBack();
      }
    } else {
      history.goBack();
    }
  };

  const enabled = tags.some((tag) => tag.isSelected);

  return (
    <div className="content_sec wf-section">
      <div className="login_sec w-form">
        <form onSubmit={handleSubmit}>
          <div className="form_field_content interest">
            <div className="interests_info_block">
              <h1>מהם תחומי העניין שלך?</h1>
              <div>
                בעזרתם נוכל להכיר לך את האנשים שהכי מתאימים לך. אפשר לבחור{" "}
                <strong>עד 8 תחומים:</strong>
              </div>
            </div>
            <ul role="list" className="interest_list w-list-unstyled">
              {tags.map((tag: Tag) => {
                return (
                  <li
                    key={tag.value}
                    className="interest_item"
                    onClick={() => handleTagSelect(tag.value)}
                  >
                    <a
                      href="#"
                      className={`interest_link w-inline-block ${
                        tag.isSelected && "in"
                      }`}
                    >
                      <img
                        src={`/assets/images/${
                          tag.isSelected
                            ? "ic_in_circle.svg"
                            : "ic_plus_circle.svg"
                        }`}
                        loading="lazy"
                        alt=""
                        className="interest_icon"
                      />
                      <div className="interest_txt">{tag.text}</div>
                    </a>
                  </li>
                );
              })}
            </ul>
            {error && <p style={{ color: "red" }}>{error}</p>}
            <a href="#" className="skip_link clear" onClick={handleUnselectAll}>
              אני רוצה לבחור הכל מחדש
            </a>
            <input
              autoComplete="off"
              type="submit"
              value="בחרתי"
              data-wait=""
              disabled={!enabled}
              className={
                enabled ? "button_full w-button" : "button_full send w-button"
              }
            />
            {props.question.skipButtonLink && (
              <a
                href="#"
                onClick={(e: any) => {
                  setTags([]);
                  handleSubmit(e, true);
                }}
                className="skip_link"
              >
                {props.question.skipButtonLink}
              </a>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}

export default InterestQuestion;
